import MainPage from "./UI";

import { CorpGlobalSearchListControllerContextProvider } from "../Controller";

const SearchGlobalCorp = () => {
  return (
    <CorpGlobalSearchListControllerContextProvider>
      <MainPage />
    </CorpGlobalSearchListControllerContextProvider>
  );
};
export default SearchGlobalCorp;
